export default {
    state: {
        consultantDetails: null,
        jobId: null,
        phoneNumber: '',
        empDetails: '',
    },

    mutations: { // https://vuex.vuejs.org/en/mutations.html
        updateConsultantDetails(state, consultantDetails) {
            state.consultantDetails = consultantDetails;
        },
        updateJobId(state, jobid){
            state.jobId = jobid;
        },
        updatePhoneNumber(state, phoneNumber){
            state.phoneNumber = phoneNumber
        },
        updateEmpStartDate(state, empStartDate){
            state.empStartDate = empStartDate
        },
        updateEmpDetails(state, empDetails){
            state.empDetails = empDetails
        }        
    },
    getters: { // https://vuex.vuejs.org/en/getters.html
        getConsultantDetails(state) {
            return state.consultantDetails;
        },
        getJobId(state){
            return state.jobId;
        },
        getPhoneNumber(state){
            return state.phoneNumber;
        },
        getEmpStartDate(state){
            return state.empStartDate;
        },
        getEmpDetails(state){
            return state.empDetails
        }
    }
}


// WEBPACK FOOTER //
// ./src/store/modules/Profile/index.js